export enum HRNSampleStatusOptionId {
  PRIOR_TO_SAMPLE_COLLECTION = 'priorToCollection',
  PRIOR_TO_RESULT_RETURN = 'priorToResultReturn',
  AFTER_RESULT_RETURN = 'afterResultReturn',
}
